import React from "react";
import {
  Badge,
  Avatar,
  Menu,
  Dialog,
  MenuItem,
  DialogContent,
  DialogTitle,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography,
  Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { IDialog } from "../../app/types";
import { useAppSelector } from "../../app/hooks";
import avatar from "../../img/avatar.png";
import { setMainContentDialogPopUp } from "../MainContent/MainContentSlice";

/* Functional component properties */
interface Props {
  classes: any;
  item: string | number | any[];
  buttonClickHandler: (btn: any) => void;
  handleDialogOpen: (data: IDialog) => void;
}

/* React Functional component */
export const AnchorMenu: React.FC<Props> = ({
  /* Function arguments (Props) */
  classes,
  item,
  buttonClickHandler,
  handleDialogOpen,
}): JSX.Element => {
  /* Accessing theme */
  const state = useAppSelector((state) => state);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [open, setOpen] = React.useState(false);
  // const [badgeContent, setBadgeContent] = React.useState(0);
  const [dialogTitle, setDialogTitle] = React.useState("");
  const [dialogContent, setDialogContent] = React.useState("");

  const handleAnchorClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    // setBadgeContent(0);
  };

  const handleAnchorClose = () => {
    setAnchorEl(null);
  };

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(null);

    switch ((event.target as HTMLElement).id) {
      case "Session Info":
        var data = {
          header: (event.target as HTMLElement).id,
          content: {
            title: "",
            details: {} as {
              [key: string]: string;
            },
          },
        };

        if (Object.keys(state.appBar.loginInfo).length) {
          Object.keys(state.appBar.loginInfo.data)
            .filter(
              (key) => ["environment", "jobnumber", "version"].indexOf(key) >= 0
            )
            .map((key) => {
              switch (key) {
                case "environment":
                  data.content.details["Environment"] =
                    state.appBar.loginInfo.data[key];
                  break;

                case "jobnumber":
                  data.content.details["MDCMS Job No"] =
                    state.appBar.loginInfo.data[key];
                  break;

                case "version":
                  data.content.details["Version"] =
                    state.appBar.loginInfo.data[key];
                  break;

                default:
                  break;
              }
            });

          state.appBar.loginInfo.headers["x-mdrsrvjob"]
            .split("-")
            .forEach((value, idx) => {
              switch (idx) {
                case 0:
                  data.content.details["API Object"] = value;
                  break;

                case 1:
                  data.content.details["API LibName"] = value;
                  break;

                case 2:
                  data.content.details["HTTP Instance"] = value;
                  break;

                case 3:
                  data.content.details["CGI Job No"] = value;
                  break;

                default:
                  break;
              }
            });
        } else {
          data.content.title = "No Session data";
        }

        handleDialogOpen(data);
        break;

      case "Logoff":
        buttonClickHandler({
          name: "LOGOFF",
        });
        break;

      case "Reload App":
        buttonClickHandler({
          name: "RELOAD",
        });
        break;

      default:
        break;
    }
  };

  /* Rendering right side components of topbar */
  return (
    <div>
      <Badge>
        <Avatar alt="image" src={avatar} onClick={handleAnchorClick} />
      </Badge>

      {/* Rendering dropdown menu for notification/account info click */}
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleAnchorClose}
      >
        {Array.isArray(item)
          ? item.map((val) =>
              val !== "Logoff" ||
              (val === "Logoff" &&
                state.mainContent.fieldList.find(
                  (fld) =>
                    fld.name === "USRID" &&
                    (!fld.editable ||
                      (fld.editable && fld.editable === "false")) &&
                    fld.value &&
                    fld.value != ""
                ) !== undefined) ? (
                <MenuItem
                  key={val}
                  id={val}
                  onClick={(e) => handleMenuClick(e)}
                >
                  {val}
                </MenuItem>
              ) : (
                ""
              )
            )
          : ""}
      </Menu>
    </div>
  );
};
